import { render, staticRenderFns } from "./documentos.vue?vue&type=template&id=0f7e6c96&scoped=true"
import script from "./documentos.vue?vue&type=script&lang=js"
export * from "./documentos.vue?vue&type=script&lang=js"
import style0 from "./documentos.vue?vue&type=style&index=0&id=0f7e6c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e6c96",
  null
  
)

export default component.exports